import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './AppShell.js';
import { Home } from '../screens/Home.js';
import { Games } from '../screens/Games.js';
import { GameHub } from '../screens/GameHub.js';
import { GameSetPicker } from '../screens/GameSetPicker.js';
import { Placeholder } from '../screens/Placeholder.js';
import { Login } from '../screens/Login.js';
import { Register } from '../screens/Register.js';
import { ForgotPassword } from '../screens/ForgotPassword.js';
import { Profile } from '../screens/Profile.js';
import { GameOverview } from '../screens/GameOverview.js';
import { TrophyList } from '../screens/TrophyList.js';

/**
 * Zielstruktur aus dem Production Handoff, Abschnitt A.
 * Alle Routen existieren bereits; die Screens werden Schritt fuer Schritt
 * aus dem eingefrorenen Prototyp migriert.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Home /> },
      { path: 'welcome', element: <Placeholder title="Welcome / Onboarding" /> },
      { path: 'games', element: <Games /> },
      { path: 'search', element: <Placeholder title="Suche" /> },

      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: 'forgot-password', element: <ForgotPassword /> },

      { path: 'profile', element: <Profile /> },
      { path: 'profile/edit', element: <Placeholder title="Profil bearbeiten" /> },
      { path: 'profile/:psnAccountId', element: <Placeholder title="Öffentliches PSN-Profil" /> },

      { path: 'settings', element: <Placeholder title="Einstellungen" /> },
      { path: 'settings/psn', element: <Placeholder title="PSN-Konto" /> },
      { path: 'settings/consoles', element: <Placeholder title="Konsolen" /> },
      { path: 'settings/theme', element: <Placeholder title="Theme" /> },
      { path: 'settings/notifications', element: <Placeholder title="Benachrichtigungen" /> },
      { path: 'settings/language', element: <Placeholder title="Sprache" /> },

      { path: 'help', element: <Placeholder title="FAQ / Hilfe" /> },
      { path: 'feedback', element: <Placeholder title="Feedback" /> },
      { path: 'contact', element: <Placeholder title="Kontakt" /> },
      { path: 'privacy', element: <Placeholder title="Datenschutz" /> },
      { path: 'imprint', element: <Placeholder title="Impressum" /> },

      { path: 'game/:gameId', element: <GameSetPicker /> },
      { path: 'game/:gameId/notes', element: <Placeholder title="Notizen" /> },
      {
        path: 'game/:gameId/set/:trophySetId',
        element: <GameHub />,
        children: [
          { index: true, element: <GameOverview /> },
          { path: 'trophies', element: <TrophyList /> },
          { path: 'trophy/:trophyId', element: <Placeholder title="Trophy Detail" /> },
          {
            path: 'roadmap',
            element: (
              <Placeholder
                title="Roadmap"
                note="Hängt am Game, sofern es kein Override für diese Version gibt."
              />
            ),
          },
          {
            path: 'completion',
            element: (
              <Placeholder
                title="100 %"
                note="Ingame Completion – nicht Trophy Completion. Hängt am Game, sofern es kein Override für diese Version gibt."
              />
            ),
          },
          { path: 'more', element: <Placeholder title="Mehr" /> },
          { path: 'missables', element: <Placeholder title="Missables" /> },
          { path: 'dlc', element: <Placeholder title="DLC / Zusatzinhalte" /> },
        ],
      },

      {
        path: 'vmaps/:gameId/*',
        element: (
          <Placeholder
            title="vMaps"
            note="Eigener Bereich. Die bestehenden vMaps-Projekte werden separat integriert – siehe docs/vmaps-integration.md."
          />
        ),
      },

      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
